/**
 * Decorative football pitch seen in perspective from the top of the page.
 * Sits behind content and fades out before/through the title area.
 */
const PitchBackground = () => {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 top-0 z-0 h-[70vh] overflow-hidden"
      style={{
        maskImage:
          "linear-gradient(to bottom, black 0%, black 55%, rgba(0,0,0,0.6) 75%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(to bottom, black 0%, black 55%, rgba(0,0,0,0.6) 75%, transparent 100%)",
      }}
    >
      <svg
        viewBox="0 0 1000 700"
        preserveAspectRatio="xMidYMin slice"
        className="absolute inset-0 h-full w-full"
      >
        <defs>
          {/* Subtle grass stripe gradient using theme tokens */}
          <linearGradient id="pitchFill" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="hsl(145 55% 18%)" stopOpacity="0.55" />
            <stop offset="100%" stopColor="hsl(150 30% 8%)" stopOpacity="0" />
          </linearGradient>

          {/* Mowed stripes pattern */}
          <pattern
            id="stripes"
            width="100"
            height="60"
            patternUnits="userSpaceOnUse"
          >
            <rect width="100" height="60" fill="hsl(145 50% 16%)" fillOpacity="0.18" />
            <rect y="30" width="100" height="30" fill="hsl(145 60% 22%)" fillOpacity="0.18" />
          </pattern>
        </defs>

        {/*
          Perspective trapezoid pitch — wider at the top, narrowing toward viewer.
          Anchored to the top-right corner so it skews dynamically off-axis.
        */}
        <g
          style={{
            transformOrigin: "center top",
          }}
        >
          {/* Pitch surface in perspective */}
          <polygon
            points="-200,-50 1300,-50 1050,720 -50,720"
            fill="url(#pitchFill)"
          />
          <polygon
            points="-200,-50 1300,-50 1050,720 -50,720"
            fill="url(#stripes)"
          />

          {/* Outer pitch boundary */}
          <polygon
            points="50,20 950,20 1020,680 -20,680"
            fill="none"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.35"
            strokeWidth="2.5"
          />

          {/* Halfway line */}
          <line
            x1="60"
            y1="350"
            x2="940"
            y2="350"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.32"
            strokeWidth="2"
          />

          {/* Center circle (ellipse for perspective) */}
          <ellipse
            cx="500"
            cy="350"
            rx="120"
            ry="40"
            fill="none"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.32"
            strokeWidth="2"
          />
          <circle
            cx="500"
            cy="350"
            r="3"
            fill="hsl(140 15% 88%)"
            fillOpacity="0.4"
          />

          {/* Top penalty box (far end) */}
          <rect
            x="320"
            y="20"
            width="360"
            height="90"
            fill="none"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.32"
            strokeWidth="2"
          />
          {/* Top six-yard box */}
          <rect
            x="410"
            y="20"
            width="180"
            height="35"
            fill="none"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.32"
            strokeWidth="2"
          />
          {/* Top penalty arc */}
          <path
            d="M 430 110 Q 500 145 570 110"
            fill="none"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.32"
            strokeWidth="2"
          />

          {/* Bottom penalty box (near end, wider due to perspective) */}
          <polygon
            points="280,560 720,560 760,680 240,680"
            fill="none"
            stroke="hsl(140 15% 88%)"
            strokeOpacity="0.32"
            strokeWidth="2"
          />
        </g>
      </svg>
    </div>
  );
};

export default PitchBackground;
